import { render, staticRenderFns } from "./DropFileContenidoTickets.vue?vue&type=template&id=35e205d2&scoped=true"
import script from "./DropFileContenidoTickets.vue?vue&type=script&lang=js"
export * from "./DropFileContenidoTickets.vue?vue&type=script&lang=js"
import style0 from "./DropFileContenidoTickets.vue?vue&type=style&index=0&id=35e205d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e205d2",
  null
  
)

export default component.exports